module.exports = __webpack_public_path__ + "img/spaghetti-monster-flying.469c1353.svg";